import axios from 'axios';
import { Url } from '../Constants/Url';
import AxiosApiService from './AxiosService';
import { waitForElementToBeRemoved } from '@testing-library/react';

interface FacilityBarrelSummary {
  facility: string;
  totalBarrels: number;
  wdtsFacilities: number;
  externalFacilities: number;
}

export const InventoryApiService = {
    getInventoryCSV, readCSV, updateInventoryCSV, downloadCSV, getInventorySellRequestWithDocs, downloadZipWithDocs, downloadDoc,
    getCsvBySellReqId, getSellReqById, getCsvHistoryBySellReqId, getCsvDocBySellReqId, showPDFForSellRequest, getInventorySellRequestsByCompanyId,
    showPDFForOrder,getMyInventories, getBarrelById, editBarrel, getInventoryChangeRequests, getInventoryChangeRequestById, 
    updateInventoryChangeRequestStatus, getAllInventoryChangeRequests, downloadInventoryTemplate, getAllDuplicateInventory, getInventoryListByCompanyId, searchInventory, fetchUnreadMessageCount, getAllBarrelsCount,
    getMyBarrelsProduct, getActiveInventoryListings,getInventoryListingDetailsRequest, getInventoryListingDetailsByStatusRequest, showPDFForOffer, showPDFForSample, getProductDetailsByInventoryId, getActiveSoldInventoryListings,
    getSoldInventoryListingDetailsRequest, getSoldInventoryListingDetailsByStatusRequest, exportMyInventories, exportMyBarrelsProduct, downloadExportFile, getAllSyncJobLog, exportKeghoundBarrelSyncLog, getContractPricingDetailsById,
    getAllOwnershipTransferLog, getAllOwnershipTransferLotLog, getAllOwnershipTransferLotBarrels, manualSync, getBarrelInsurancePricing, saveInsurancePrice, saveContractServicePrice, saveWarehouseDetails, fetchAllCompaniesContracts, fetchAllContractPricing,
    getBarrelMarketValue, getBarrelMarketValueHistory, updateBarrelMarketValue, getMarketValueWithFilter, getAllLotNoByCompanyId, downloadMarketValueReport, downloadMarketValueExportFile, fetchExistingWarehouse, fetchExistingServicePricing, saveCompanyContract, 
    getContractById, getNextContractId, fetchAllCompaniesContractCapacity, fetchCapacityDetailsByCompanyId, fetchBarrelOwnerConflictCount, getProofHistoryByBarrelNumber, fetchAllPalletsByWarehouseId, getPalletWithBarrelDetails, fetchLocationsByWarehouseId,
    getValuationHistoryByBarrelId, getWarehouseDropdown, getAllWarehouseBarrel, getPalletDetailsById, searchInventoryForDestination, getContainerBarrelDetailsById, getContainerTimeLineOverlayBarrelDetailsById, getRecentLiquidFillDetailsById, 
    getContainerRequestMappingHistoryDetails, getContainerBarrelHistoryDetailsById, getTastingDetails, addTastingNote, downloadReport, getMyBarrelsFacilities, getFacilityBarrelSummary, exportMyBarrelsFacilities, downloadFacilitiesExportFile, getBarrelLotLevelList, editBarrelLotLevel,
    getAllWarehouseStagingArea, getMaxWarehouseRow, getMaxWarehouseStack, getBarrelDetailsByLocation, exportMyLogisticRequest, downloadLogisticRequestExportFile, getActiveOwnershipTransferListings, exportMyOwnershipTransfer, downloadOwnershipTransferExportFile, 
    getCompaniesContainerCount, exportCompanyInventorySummary, downloadCompanyInventorySummaryReport, getCompanyBillingActivity, exportCompanyBillingActivity, downloadCompanyBillingActivityReport, getTTBReport, exportTTBReport, downloadTTBReport,
    getBillableServiceTypes, getServiceRequestBillingDetail, exportServiceRequestBillingDetail, getServiceRequestBillingSummary, exportServiceRequestBillingSummary, downloadServiceRequestBillingReport, getInventoryFilterOptions,
    getCompanyBulkInventoryUploadReport, exportCompanyBulkInventoryUploadReport, downloadCompanyBulkInventoryUploadReport,searchInventoryGrid
    
}

async function getInventoryCSV(id:any,page:any,size:any,isFetchOpenRequests:boolean, filter: any, signal: AbortSignal) {
    // return await AxiosApiService.postWithSearchParams<Object>(Url.GET_INVENTORY_CSV, 
    // {
    //     companyId:id,
    //     page:page,
    //     size:size,
    //     isFetchOpenRequests:isFetchOpenRequests
    // }, filter, { signal });
}

async function getCsvBySellReqId(id : any) {
    let path = Url.GET_CSVs_BY_SELL_REQUEST_ID + "/" + id;
    return await AxiosApiService.get<Object>(path);
}

async function getCsvHistoryBySellReqId(id : any) {
    let path = Url.GET_HISTORY_BY_SELL_REQUEST_ID + "/" + id;
    return await AxiosApiService.get<Object>(path);
}

async function getCsvDocBySellReqId(id : any) {
    let path = Url.GET_DOCS_BY_SELL_REQUEST_ID + "/" + id;
    return await AxiosApiService.get<Object>(path);
}

async function getSellReqById(id : any) {
    let path = Url.GET_SELL_REQ_BY_ID_WITH_COMPANY + "/" + id;
    return await AxiosApiService.get<Object>(path);
}

async function readCSV(csvId: any) {
    return await AxiosApiService.get<Object>(Url.READ_CSV + '/' + csvId);
}

async function updateInventoryCSV(formData: any) {
    return await AxiosApiService.put<any>(Url.UPDATE_INVENTORY_CSV, formData);
}

async function downloadCSV(csvData: any) {
    return await AxiosApiService.postBlob<Object>(Url.DOWNLOAD_CSV, csvData);
}

async function downloadInventoryTemplate() {
    return await AxiosApiService.getBlob<Object>(Url.DOWNLOAD_INVENTORY_TEMPLATE);
}

async function getInventorySellRequestWithDocs(csvId: any) {
    return await AxiosApiService.get<Object>(Url.GET_INVENTORY_CSV_WITH_DOCS + '/' + csvId);
}

async function downloadZipWithDocs(csvId: any) {
    return await AxiosApiService.getZip<Object>(Url.DOWNLOAD_ZIP_WITH_DOCS + '/' + csvId);
}

async function downloadDoc(downloadDoc: any) {
    return await AxiosApiService.postBlob<Object>(Url.DOWNLOAD_DOC, downloadDoc);
}

async function showPDFForSellRequest(id:any, companyId:any, siteId:any, fileName:any, requestNumber:any) {
    return await AxiosApiService.getBlob<Object>(`${Url.SHOW_PDF_URL}?id=${id}&companyId=${companyId}&siteId=${siteId}&fileName=${fileName}&requestNumber=${requestNumber}`);
}

async function showPDFForOrder(id:any, companyId:any, siteId:any, fileName:any, requestNumber:any) {
    return await AxiosApiService.getBlob<Object>(`${Url.SHOW_PDF_FOR_ORDER_URL}?id=${id}&companyId=${companyId}&siteId=${siteId}&fileName=${fileName}&requestNumber=${requestNumber}`);
}

async function showPDFForOffer(id:any, companyId:any, siteId:any, fileName:any, requestNumber:any) {
    return await AxiosApiService.getBlob<Object>(`${Url.SHOW_PDF_FOR_OFFER_URL}?id=${id}&companyId=${companyId}&siteId=${siteId}&fileName=${fileName}&requestNumber=${requestNumber}`);
}

async function showPDFForSample(id:any, companyId:any, siteId:any, fileName:any, requestNumber:any) {
    return await AxiosApiService.getBlob<Object>(`${Url.SHOW_PDF_FOR_SAMPLE_URL}?id=${id}&companyId=${companyId}&siteId=${siteId}&fileName=${fileName}&requestNumber=${requestNumber}`);
}

async function getInventorySellRequestsByCompanyId(companyId: any,page:any, size:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_COMPANY_WISE_SELL_REQUEST + '/' + companyId,{
        params: {
            page:page,
            size:size,
        }
    });
}
async function getMyInventories(service, companyId: any,selectedTab: string, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal, activeButton: any) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_MY_INVENTORIES ,
            {
                serviceType: service,
                companyId: companyId,
                selectedTab: selectedTab,
                activeButton: activeButton,
                page: page,
                size: size,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function exportMyInventories(service, companyId: any,selectedTab: string, filter: any, sortField: any, sortDirection: any, activeButton: any) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_MY_INVENTORIES ,
            {
                serviceType: service,
                companyId: companyId,
                selectedTab: selectedTab,
                activeButton: activeButton,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter
    );
}

async function downloadExportFile(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_EXPORT_BARREL ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
            notificationId: notificationId
        }
    }   
    );
}

async function downloadFacilitiesExportFile(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_FACILITIES_EXPORT_BARREL ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
            notificationId: notificationId
        }
    }   
    );
}

async function downloadOwnershipTransferExportFile(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_OWNERSHIP_TRANSFER_EXPORT_BARREL ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
            notificationId: notificationId
        }
    }   
    );
}

async function downloadMarketValueExportFile(companyId: any,userId: any, fileName: any) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_MARKET_VALUE_REPORT ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
        }
    }   
    );
}

async function downloadReport(userId: any, fileName: any, requestNumber:any) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_REPORT ,
        {params: {
            userId: userId,
            fileName: fileName,
            requestNumber: requestNumber
        }
    }   
  );
}

async function getBarrelById(barrelId: any) {
    return await AxiosApiService.get<any>(Url.GET_BARREL_BY_ID + barrelId);
}

async function editBarrel(barrelData) {
    return await AxiosApiService.post<Object>(Url.EDIT_BARREL, barrelData);
}

async function getProofHistoryByBarrelNumber(barrelNumber: any, page: any, size: any, sortField: any, sortDirection: any, filter:any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_PROOF_HISTORY_BY_BARREL_NUMBER,
        {
            barrelNumber: barrelNumber,
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection
        }, filter, { signal });
}

async function getValuationHistoryByBarrelId(barrelId: any, page: any, size: any, sortField: any, sortDirection: any, filter:any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_VALUATION_HISTORY_BY_BARREL_ID,
        {
            barrelId: barrelId,
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection
        }, filter, { signal });
}

async function getInventoryChangeRequests(companyId: any, isFetchOpenRequests: any) {
    return await AxiosApiService.get<Object>(Url.GET_INVENTORY_CHANGE_REQUESTS + '/' + companyId + '/' + isFetchOpenRequests);
}

async function getInventoryChangeRequestById(id: any) {
    return await AxiosApiService.get<Object>(Url.GET_INVENTORY_CHANGE_REQUEST_BY_ID + '/' + id);
}

async function updateInventoryChangeRequestStatus(statusDetails: any) {
    return await AxiosApiService.put<any>(Url.UPDATE_INVENTORY_CHANGE_REQUEST_STATUS, statusDetails)
}

async function getAllInventoryChangeRequests() {
    return await AxiosApiService.get<Object>(Url.GET_ALL_INVENTORY_CHANGE_REQUESTS);
}

async function getAllDuplicateInventory() {
    return await AxiosApiService.get<Object>(Url.GET_ALL_DUPLICATE_INVENTORY);
}

async function getInventoryListByCompanyId(companyId:any) {
    return await AxiosApiService.get<any>(Url.GET_INVENTORY_LIST_BY_COMPANY_ID + "/" + companyId);
}

async function searchInventory(inventorySearchRequestForCustomerService:any) {
    return await AxiosApiService.post<any>(Url.SEARCH_INVENTORY, inventorySearchRequestForCustomerService)
}

async function fetchUnreadMessageCount (sellRequestId: any) {
    return await AxiosApiService.get<any> (Url.FETCH_UNREAD_MESSAGE_COUNT_FOR_SELL_REQUEST + '/' + sellRequestId);
}

async function getAllBarrelsCount (inventoryId: any) {
    return await AxiosApiService.get<any> (Url.FETCH_ALL_BARRELS_COUNT + '/' + inventoryId);
}

async function getMyBarrelsProduct(service,companyId: any,selectedTab: string, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal, activeButton: any) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_MY_BARRELS_PRODUCT ,
            {
                serviceType: service,
                companyId: companyId,
                selectedTab: selectedTab,
                activeButton: activeButton,
                page: page,
                size: size,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function exportMyBarrelsProduct(service,companyId: any,selectedTab: string, filter: any, sortField: any, sortDirection: any, signal: AbortSignal, activeButton: any) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_MY_BARRELS_PRODUCT ,
            {
                serviceType: service,
                companyId: companyId,
                selectedTab: selectedTab,
                activeButton: activeButton,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function getActiveInventoryListings(companyId: any, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_INVENTORIES_LISTING ,
            {
                companyId: companyId,
                page: page,
                size: size,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function getActiveOwnershipTransferListings(companyId: any, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.FETCH_OWNERSHIP_TRANSFER_LISTING ,
            {
                companyId: companyId,
                page: page,
                size: size,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function getInventoryListingDetailsRequest(inventoryId: any) {
    return await AxiosApiService.get<any>(Url.GET_INVENTORIES_LISTING_BY_INVENTORY_ID + '/' + inventoryId);
}

async function getInventoryListingDetailsByStatusRequest(inventoryId: any, activeSection: any, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_INVENTORIES_LISTING_BY_INVENTORY_ID_AND_STATUS ,
            {
                inventoryId: inventoryId,
                activeSection: activeSection,
                page: page,
                size: size,
                sortField: sortField, 
                sortDirection: sortDirection
            }, filter, { signal }
    );
}

async function getProductDetailsByInventoryId(inventoryId: any) {
    return await AxiosApiService.get<any>(Url.GET_PRODUCT_DETAILS_BY_INVENTORY_ID + '/' + inventoryId);
}

async function getActiveSoldInventoryListings(companyId: any, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_SOLD_INVENTORIES_LISTING ,
            {
                companyId: companyId,
                page: page,
                size: size,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function getSoldInventoryListingDetailsRequest(inventoryId: any) {
    return await AxiosApiService.get<any>(Url.GET_SOLD_INVENTORIES_LISTING_BY_INVENTORY_ID + '/' + inventoryId);
}

async function getSoldInventoryListingDetailsByStatusRequest(inventoryId: any, activeSection: any, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_SOLD_INVENTORIES_LISTING_BY_INVENTORY_ID_AND_STATUS ,
            {
                inventoryId: inventoryId,
                activeSection: activeSection,
                page: page,
                size: size,
                sortField: sortField, 
                sortDirection: sortDirection
            }, filter, { signal }
    );
}

async function getAllSyncJobLog(page: any, size: any, filter:any, sortField:any , sortDirection:any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_SYNC_JOB_LOG ,
        {
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection
        }, filter, { signal }
    );
}

async function exportKeghoundBarrelSyncLog(jobId: any) {
    return await AxiosApiService.get<any>(Url.EXPORT_KEGHOUND_BARREL_SYNC_LOG + '/' + jobId);
}

async function getAllOwnershipTransferLog(page: any, size: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_OWNERSHIP_TRANSFER_LOG,
        {
            page: page,
            size: size
        }, { signal }
    );
}

async function getAllOwnershipTransferLotLog(transferRequestId: any) {
    return await AxiosApiService.get<any>(Url.GET_OWNERSHIP_TRANSFER_LOT_LOG + '/' + transferRequestId);
}

async function getAllOwnershipTransferLotBarrels(transferLotRequestId: any) {
    return await AxiosApiService.get<any>(Url.GET_OWNERSHIP_TRANSFER_LOT_LOG_BARREL + '/' + transferLotRequestId);
}

async function manualSync(transferRequestId: any) {
    return await AxiosApiService.get<any>(Url.MANUAL_SYNC_BY_TRANSFER_REQUEST_ID + '/' + transferRequestId);
}

async function getBarrelInsurancePricing(year: any) {
    return await AxiosApiService.get<any>(Url.GET_BARREL_INSURANCE_PRICING + '/' + year);
}

async function getBarrelMarketValue(companyId: any, page:any, size:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_BARREL_MARKET_VALUES + '/' + companyId, {
        params: {
            page: page,
            size: size
        }
    });
}

async function getBarrelMarketValueHistory(barrelLotValueId: any) {
    return await AxiosApiService.get<any>(Url.GET_BARREL_MARKET_VALUE_HISTORY + '/' + barrelLotValueId);
}

async function updateBarrelMarketValue(request:any) {
    return await AxiosApiService.post<any>(Url.UPDATE_BARREL_MARKET_VALUE, request);
}

async function saveInsurancePrice(request:any) {
    return await AxiosApiService.post<any>(Url.SAVE_INSURANCE_PRICING, request);
}

async function getMarketValueWithFilter(companyId:any, lotId:any, year:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_MARKET_VALUE_WITH_FILTER, {
        params: {
            companyId: companyId,
            barrelLotId: lotId,
            year: year,
        }
    })
}

async function getAllLotNoByCompanyId(companyId:any) {
    return await AxiosApiService.get<any>(Url.GET_ALL_LOT_NO_BY_COMPANY_ID + "/" + companyId);
}

async function downloadMarketValueReport(companyId:any, year:any) {
    return await AxiosApiService.getWithParams<any>(Url.PROCESS_MARKET_VALUE_REPORT, {
        params: {
            companyId: companyId,
            year: year
        }
    })
}

async function saveContractServicePrice(request:any) {
    return await AxiosApiService.post<any>(Url.SAVE_CONTRACT_SERVICE_PRICE, request)
}

async function saveWarehouseDetails(request:any) {
    return await AxiosApiService.post<any>(Url.SAVE_WAREHOUSE_DETAILS, request)
}

async function fetchExistingWarehouse () {
    return await AxiosApiService.get<any>(Url.FETCH_EXISTING_WAREHOUSE)
}

async function fetchExistingServicePricing () {
    return await AxiosApiService.get<any>(Url.FETCH_EXISTING_SERVICE_PRICING)
}

async function saveCompanyContract (request:any) {
    return await AxiosApiService.post<any>(Url.SAVE_COMPANY_CONTRACT, request)
}

async function getContractById (id:any) {
    return await AxiosApiService.get<any>(Url.GET_CONTRACT_DETAILS_BY_ID + '/' + id);
}

async function getContractPricingDetailsById (id:any) {
    return await AxiosApiService.get<any>(Url.FETCH_CONTRACT_PRICING_DETAILS_BY_ID + '/' + id);
}

async function fetchAllCompaniesContracts (page:any, size:any, sortField:any, sortDirection:any, filter:any, companyId:any, signal:AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.FETCH_ALL_COMPANIES_CONTRACT,   {
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection,
            companyId: companyId
        }, filter, { signal }
    );
}

async function fetchAllContractPricing (page:any, size:any, sortField:any, sortDirection:any, filter:any, signal:AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.FETCH_ALL_CONTRACT_PRICING_DETAILS,   {
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection,
        }, filter, { signal }
    );
}

async function getNextContractId(contractType:any, date:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_NEXT_CONTRACT_ID, {
        params: {
            contractType: contractType,
            date: date
        }
    })
}

async function fetchAllCompaniesContractCapacity (page:any, size:any, sortField:any, sortDirection:any, filter:any, companyId:any, signal:AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.FETCH_ALL_COMPANIES_CONTRACT_CAPACITY,   {
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection,
        }, filter, { signal }
    );
}

async function fetchCapacityDetailsByCompanyId(companyId:any) {
    return await AxiosApiService.get<any>(Url.GET_CAPACITY_DETAILS_BY_COMPANY_ID + '/' + companyId);
}

async function fetchBarrelOwnerConflictCount(barrelIds:any) {
    return await AxiosApiService.post<any>(Url.GET_BARREL_OWNER_CONFLICT_COUNT, barrelIds)
}

async function searchInventoryForDestination(inventorySearchRequestForCustomerService:any) {
    return await AxiosApiService.post<any>(Url.SEARCH_INVENTORY_FOR_DESTINATION, inventorySearchRequestForCustomerService)
}

async function fetchAllPalletsByWarehouseId(warehouseId:any,page:any, size:any, sortField:any, sortDirection:any, filter:any, signal:AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_PALLETS + "/" + warehouseId, {
            page : page,
            size : size,
            sortField : sortField,
            sortDirection : sortDirection,
    }, filter,  { signal }
  );
}

async function getPalletWithBarrelDetails(warehouseId:any, locationId:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_PALLET_WITH_BARREL_DETAILS, {
        params: {
            warehouseId: warehouseId,
            locationId: locationId
        }
    })
}
async function fetchLocationsByWarehouseId(warehouseName:any) {
    return await AxiosApiService.get<any>(Url.GET_ALL_LOCATIONS + "/" + warehouseName)
}

async function getWarehouseDropdown() {
    return await AxiosApiService.get<any>(Url.GET_WAREHOUSE_DROPDOWN)
}

async function getPalletDetailsById(palletId:any) {
    return await AxiosApiService.get<any>(Url.GET_PALLET_DETAILS + "/" + palletId);
}

async function getAllWarehouseBarrel(warehouseId:any,page:any, size:any, sortField:any, sortDirection:any, filter:any, signal:AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_WAREHOUSE_BARRELS + "/" + warehouseId, {
            page : page,
            size : size,
            sortField : sortField,
            sortDirection : sortDirection,
    }, filter,  { signal }
  );
}

async function getContainerBarrelDetailsById(barrelId: any) {
    return await AxiosApiService.get<Object>(Url.GET_LIQUID_BARREL_DETAILS_BY_ID + barrelId);
}

async function getContainerTimeLineOverlayBarrelDetailsById(barrelId: any) {
    return await AxiosApiService.get<Object>(Url.GET_CONTAINER_TIME_LINE_OVERLAY_BY_ID + barrelId);
}

async function getRecentLiquidFillDetailsById(barrelId: any) {
    return await AxiosApiService.get<Object>(Url.GET_RECENT_LIQUID_FILL_DETAILS_BY_ID + barrelId);
}

async function getContainerRequestMappingHistoryDetails(barrelId: any, barrelNumber: any, lotNo: any, page: any, size: any, sortField: any, sortDirection: any, filter:any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_CONTAINER_REQUEST_MAPPING_HISTORY_BARREL_DETAILS,
        {
            barrelId: barrelId,
            barrelNumber: barrelNumber,
            lotNo: lotNo,
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection
        }, filter, { signal });
}

async function getMyBarrelsFacilities(service, companyId: any,selectedTab: string, page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal, activeButton: any) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_MY_FACILITIES ,
        {
            serviceType: service, companyId: companyId, selectedTab: selectedTab, activeButton: activeButton,
            page: page, size: size, sortField: sortField, sortDirection: sortDirection,
        }, filter, { signal }
    );
}

async function getFacilityBarrelSummary(companyId: any, filter?: any) {
    return await AxiosApiService.postWithSearchParams<FacilityBarrelSummary>(Url.GET_ALL_FACILITY_BARREL_SUMMARY ,
        { companyId: companyId }, filter ?? {}
    );
}

async function exportMyBarrelsFacilities(service,companyId: any,selectedTab: string, filter: any, sortField: any, sortDirection: any, signal: AbortSignal, activeButton: any) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_MY_BARRELS_FACILITIES ,
            {
                serviceType: service,
                companyId: companyId,
                selectedTab: selectedTab,
                activeButton: activeButton,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function getContainerBarrelHistoryDetailsById(barrelId: any) {
    return await AxiosApiService.get<Object>(Url.GET_CONTAINER_BARREL_HISTORY_DETAILS_BY_ID + barrelId);
}

async function getTastingDetails(barrelId, customerServiceRequestId) {
  return await AxiosApiService.getWithParams(Url.GET_TASTING_DETAILS, {
      params: {
        barrelId: barrelId,
        customerServiceRequestId: customerServiceRequestId
      }
    });
}

async function addTastingNote(tastingData) {
    return await AxiosApiService.post<Object>(Url.ADD_TASTING_NOTE, tastingData);
}

async function getBarrelLotLevelList(barrelId: any) {
    return await AxiosApiService.get<Object>(Url.GET_BARREL_LOT_LEVEL_BY_ID + barrelId);
}

async function editBarrelLotLevel(barrelLotLevelData) {
    return await AxiosApiService.post<Object>(Url.EDIT_BARREL_LOT_LEVEL, barrelLotLevelData);
}

async function getMaxWarehouseRow(warehouse:any) {
    return await AxiosApiService.get<any> (Url.GET_MAX_WAREHOUSE_ROW + "/" + warehouse);
}

async function getMaxWarehouseStack(warehouse:any) {
    return await AxiosApiService.get<any> (Url.GET_MAX_WAREHOUSE_STACK + "/" + warehouse);
}

async function getAllWarehouseStagingArea(warehouse:any) {
    return await AxiosApiService.get<any> (Url.GET_ALL_STAGING_AREAS + "/" + warehouse);
}

async function getCompaniesContainerCount(page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal){
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_COMPANIES_CONTAINER_COUNT, 
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportCompanyInventorySummary(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_COMPANY_INVENTORY_SUMMARY ,
            {
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function downloadCompanyInventorySummaryReport(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_COMPANY_INVENTORY_SUMMARY_REPORT ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
            notificationId: notificationId
        }
    }   
    );
}

async function getCompanyBillingActivity(page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal){
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_COMPANY_BILLING_ACTIVITY, 
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportCompanyBillingActivity(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_COMPANY_BILLING_ACTIVITY ,
            {
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function downloadCompanyBillingActivityReport(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_COMPANY_BILLING_ACTIVITY_REPORT ,
        {
            params: {
                companyId: companyId,
                userId: userId,
                fileName: fileName,
                notificationId: notificationId
            }
        }   
    );
}

async function getTTBReport(page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal){
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_TTB_REPORT, 
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportTTBReport(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_TTB_REPORT ,
            {
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function downloadTTBReport(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_TTB_REPORT ,
        {
            params: {
                companyId: companyId,
                userId: userId,
                fileName: fileName,
                notificationId: notificationId
            }
        }   
    );
}

async function getBillableServiceTypes() {
    return await AxiosApiService.get<string[]>(Url.GET_BILLABLE_SERVICE_TYPES);
}

async function getServiceRequestBillingDetail(page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_SERVICE_REQUEST_BILLING_DETAIL,
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportServiceRequestBillingDetail(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_SERVICE_REQUEST_BILLING_DETAIL,
        {
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal }
    );
}

async function getServiceRequestBillingSummary(page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_SERVICE_REQUEST_BILLING_SUMMARY,
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportServiceRequestBillingSummary(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_SERVICE_REQUEST_BILLING_SUMMARY,
        {
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal }
    );
}

async function downloadServiceRequestBillingReport(companyId: any, userId: any, fileName: any, notificationId: any) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_SERVICE_REQUEST_BILLING_REPORT,
        {
            params: {
                companyId: companyId,
                userId: userId,
                fileName: fileName,
                notificationId: notificationId
            }
        }
    );
}

async function getBarrelDetailsByLocation(locationId:any, warehouseName:any) {
    return await AxiosApiService.getWithParams<any> (Url.GET_BARREL_DETAILS_BY_LOCATION, {
        params: {
            locationId: locationId,
            warehouseName: warehouseName
        }
    });
}

async function exportMyOwnershipTransfer(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_MY_OWNERSHIP_TRANSFER ,
            {
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function exportMyLogisticRequest(logisticType: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_MY_LOGISTIC_REQUEST ,
            {
                logisticType: logisticType,
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function downloadLogisticRequestExportFile(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_LOGISTIC_REQUEST_EXPORT_BARREL ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
            notificationId: notificationId
        }
    }   
    );
}

async function getInventoryFilterOptions(companyId: any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_INVENTORY_FILTER_OPTIONS, {
        params: {
            companyId: companyId ?? null,
        }
    });
}
    
async function getCompanyBulkInventoryUploadReport(page: any, size: any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<Object>(Url.GET_COMPANY_BULK_INVENTORY_UPLOAD_REPORT,
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportCompanyBulkInventoryUploadReport(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_COMPANY_BULK_INVENTORY_UPLOAD_REPORT,
        {
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal }
    );
}

async function downloadCompanyBulkInventoryUploadReport(companyId: any, userId: any, fileName: any, notificationId: any) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_COMPANY_BULK_INVENTORY_UPLOAD_REPORT,
        {
            params: {
                companyId: companyId,
                userId: userId,
                fileName: fileName,
                notificationId: notificationId
            }
        }
    );
}

async function searchInventoryGrid(
    companyId: string,
    page: number,
    size: number,
    sortField: string,
    sortDirection: string,
    filterBody?: Record<string, any>
) {
    const body: Record<string, any> = {
        companyId,
        ...(filterBody || {}),
    };
    return await AxiosApiService.postWithSearchParams<any>(
        Url.SEARCH_INVENTORY_GRID,
        { page, size, sortField, sortDirection },
        body
    );
}
